import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class ProgrammableLogicController_ds_get_containers_ready_for_plcService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { waveIds?: number[] }): 
  Promise<{ result: { Id?: number, ExpectedPackagedAmount?: number, ExpectedPackagedPackId?: number, OrderId?: number, OrderLineNumber?: number, PickSlipId?: number, ProjectId?: number, ShipmentId?: number, ShipmentLineId?: number, WarehouseId?: number, ExpectedSourceLocation?: { Id?: number, Name?: string, Path?: string }, Material?: { Id?: number, PackagingLookups?: { PackagingId?: number, Height?: number, Length?: number, ShippingVolume?: number, ShippingWeight?: number, VolumeUomId?: number, WeightUomId?: number, Width?: number, Packaging?: { ShortName?: string } }[] } }[] }> 
  {
    let $url = `${environment.backendUrl}api/ProgrammableLogicController/datasources/ds_get_containers_ready_for_plc/get`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { waveIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ExpectedPackagedAmount?: number, ExpectedPackagedPackId?: number, OrderId?: number, OrderLineNumber?: number, PickSlipId?: number, ProjectId?: number, ShipmentId?: number, ShipmentLineId?: number, WarehouseId?: number, ExpectedSourceLocation?: { Id?: number, Name?: string, Path?: string }, Material?: { Id?: number, PackagingLookups?: { PackagingId?: number, Height?: number, Length?: number, ShippingVolume?: number, ShippingWeight?: number, VolumeUomId?: number, WeightUomId?: number, Width?: number, Packaging?: { ShortName?: string } }[] } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/ProgrammableLogicController/datasources/ds_get_containers_ready_for_plc/getList`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { waveIds?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, ExpectedPackagedAmount?: number, ExpectedPackagedPackId?: number, OrderId?: number, OrderLineNumber?: number, PickSlipId?: number, ProjectId?: number, ShipmentId?: number, ShipmentLineId?: number, WarehouseId?: number, ExpectedSourceLocation?: { Id?: number, Name?: string, Path?: string }, Material?: { Id?: number, PackagingLookups?: { PackagingId?: number, Height?: number, Length?: number, ShippingVolume?: number, ShippingWeight?: number, VolumeUomId?: number, WeightUomId?: number, Width?: number, Packaging?: { ShortName?: string } }[] } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/ProgrammableLogicController/datasources/ds_get_containers_ready_for_plc/getByKeys`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      waveIds?: number[]    }) {
      return false;
    }
}
